import { useEffect, useState } from 'react';

function Thumb({ item, index, onDelete, onMove, onPreview }) {
  const [url, setUrl] = useState('');

  useEffect(() => {
    const next = URL.createObjectURL(item.thumbnail);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [item.thumbnail]);

  return (
    <li className="thumb">
      <button type="button" className="thumb-image" onClick={() => onPreview(index)}>
        <img src={url} alt={`Captured work ${index + 1}`} />
        <span>{index + 1}</span>
      </button>
      <div className="thumb-controls">
        <button type="button" aria-label={`Move photo ${index + 1} left`} disabled={!index} onClick={() => onMove(index, -1)}>←</button>
        <button type="button" aria-label={`Delete photo ${index + 1}`} onClick={() => onDelete(index)}>×</button>
        <button type="button" aria-label={`Move photo ${index + 1} right`} onClick={() => onMove(index, 1)}>→</button>
      </div>
    </li>
  );
}

export default function ThumbStrip(props) {
  return (
    <ol className="thumb-strip" aria-label="Captured photos">
      {props.images.map((item, index) => (
        <Thumb key={item.key} item={item} index={index} {...props} />
      ))}
    </ol>
  );
}